import React from 'react';
import { useState, useEffect } from "react";

import { motion } from 'framer-motion';

import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
import './Header.scss';
import TextTransition, { presets } from 'react-text-transition';
import 'animate.css';
import TrackVisibility from 'react-on-screen';


const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};



const Header = () => {
  const TEXTS = ["FullStack Developer", "Software Engineer", "UI/UX Designer", "Freelancer"];
  const [index, setIndex] =useState(0);
  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      2000, // every 2 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);

  return(
  <div className="app__header app__flex">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__header-info"
    >
      <div className="app__header-badge">
        <div className="badge-cmp app__flex">
          <span>👋</span>
          <div style={{ marginLeft: 20 }}>
            <p className="p-text">Hello, I am</p>
            <h1 className="head-text">Charbel</h1>
          </div>
        </div>

        <div className="tag-cmp app__flex">

          <p className="p-text" >
          <TextTransition springConfig={presets.stiff}>{TEXTS[index % TEXTS.length]}</TextTransition>
          </p>
          {/* <p className="p-text">FullStack Developer</p>
          <p className="p-text">Freelancer</p> */}
        </div>
      </div>
    </motion.div>
    <TrackVisibility>
    {({ isVisible }) =>
    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className={isVisible ? "animate__animated animate__zoomIn app__header-img" : "app__header-img"}
    >
      {/* <img src={images.profile} alt="profile_bg" /> */}
      
                  <img className='hearderImg' src={images.headerImg} alt="Header Img" />
          
       
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: 'easeInOut' }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      />
    </motion.div>}
    </TrackVisibility>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__header-circles"
    >
      {[images.flutter, images.javascript, images.node].map((circle, index) => (
        <div className="circle-cmp app__flex" key={`circle-${index}`}>
          <img src={circle} alt="profile_bg" />
        </div>
      ))}
    </motion.div>
  </div>
);}

export default AppWrap(Header, 'home');